import * as React from 'react';

const AmexPaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <g id="logo-payment-american-express-rebranding">
            <g id="fill">
                <path
                    d="M3 4C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18H20.9294L19.7999 16.7766L18.6705 18H11.6588V12.353H9.3999L12.2235 6H14.9529L15.9411 8.16477V6H19.3294L19.8941 7.64711L20.4588 6H23C23 4.89543 22.1046 4 21 4H3Z"
                    fill="#161719"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23 6.75306H20.9294L19.8471 9.85901L18.7176 6.75306H16.6V11.5893L14.4352 6.75306H12.6941L10.5294 11.6942H12.0352L12.4587 10.7061H14.7176L15.1411 11.6942H17.9647V8.2589L19.2353 11.6942H20.4117L21.6823 8.2589V11.6942H23V6.75306ZM13.5412 8.02364L12.8822 9.62361H14.2L13.5412 8.02364Z"
                    fill="#161719"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23 12.4472H21.2588L19.8471 14.0001L18.3882 12.4472H16.6H12.4117V17.3883H16.6H18.3412L19.7999 15.7884L21.2588 17.3883H23L20.6941 14.8942L23 12.4472ZM16.6 17.3883L18.9529 14.8942L16.6 12.4472V13.5766H13.7764V14.3295H16.5528V15.459H13.7764V16.2119H16.6V17.3883Z"
                    fill="#161719"
                />
                <path
                    d="M23 16.2589V13.5295L21.7294 14.8942L23 16.2589Z"
                    fill="#161719"
                />
            </g>
        </g>
    </svg>
);

AmexPaymentRebrandingSvg.displayName = 'AmexPaymentRebrandingSvg';
export default AmexPaymentRebrandingSvg;
